/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseComponentDefinitionDto } from '../models';
// @ts-ignore
import type { ComponentDefinitionDto } from '../models';
// @ts-ignore
import type { ComponentDefinitionIdDto } from '../models';
// @ts-ignore
import type { ComponentDefinitionSearchQueryDto } from '../models';
// @ts-ignore
import type { ComponentDefinitionsSearchResponseDto } from '../models';
/**
 * RestComponentDefinitionsApi - axios parameter creator
 */
export const RestComponentDefinitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new component definition
         * @param {BaseComponentDefinitionDto} baseComponentDefinitionDto Component definition creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinition: async (baseComponentDefinitionDto: BaseComponentDefinitionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseComponentDefinitionDto' is not null or undefined
            assertParamExists('createComponentDefinition', 'baseComponentDefinitionDto', baseComponentDefinitionDto)
            const localVarPath = `/api/component-definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseComponentDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get component definition by id
         * @param {number} componentDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentDefinitionById: async (componentDefinitionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentDefinitionId' is not null or undefined
            assertParamExists('getComponentDefinitionById', 'componentDefinitionId', componentDefinitionId)
            const localVarPath = `/api/component-definitions/{componentDefinitionId}`
                .replace('{componentDefinitionId}', encodeURIComponent(String(componentDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for component definitions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ComponentDefinitionSearchQueryDto} componentDefinitionSearchQueryDto Component definitions search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentDefinitions: async (page: number, pageSize: number, componentDefinitionSearchQueryDto: ComponentDefinitionSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchComponentDefinitions', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchComponentDefinitions', 'pageSize', pageSize)
            // verify required parameter 'componentDefinitionSearchQueryDto' is not null or undefined
            assertParamExists('searchComponentDefinitions', 'componentDefinitionSearchQueryDto', componentDefinitionSearchQueryDto)
            const localVarPath = `/api/component-definitions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentDefinitionSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestComponentDefinitionsApi - functional programming interface
 */
export const RestComponentDefinitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestComponentDefinitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new component definition
         * @param {BaseComponentDefinitionDto} baseComponentDefinitionDto Component definition creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComponentDefinition(baseComponentDefinitionDto: BaseComponentDefinitionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDefinitionIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComponentDefinition(baseComponentDefinitionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionsApi.createComponentDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get component definition by id
         * @param {number} componentDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComponentDefinitionById(componentDefinitionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComponentDefinitionById(componentDefinitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionsApi.getComponentDefinitionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for component definitions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ComponentDefinitionSearchQueryDto} componentDefinitionSearchQueryDto Component definitions search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchComponentDefinitions(page: number, pageSize: number, componentDefinitionSearchQueryDto: ComponentDefinitionSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentDefinitionsSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchComponentDefinitions(page, pageSize, componentDefinitionSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentDefinitionsApi.searchComponentDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestComponentDefinitionsApi - factory interface
 */
export const RestComponentDefinitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestComponentDefinitionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new component definition
         * @param {BaseComponentDefinitionDto} baseComponentDefinitionDto Component definition creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentDefinition(baseComponentDefinitionDto: BaseComponentDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDefinitionIdDto> {
            return localVarFp.createComponentDefinition(baseComponentDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get component definition by id
         * @param {number} componentDefinitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentDefinitionById(componentDefinitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDefinitionDto> {
            return localVarFp.getComponentDefinitionById(componentDefinitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for component definitions
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ComponentDefinitionSearchQueryDto} componentDefinitionSearchQueryDto Component definitions search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentDefinitions(page: number, pageSize: number, componentDefinitionSearchQueryDto: ComponentDefinitionSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDefinitionsSearchResponseDto> {
            return localVarFp.searchComponentDefinitions(page, pageSize, componentDefinitionSearchQueryDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestComponentDefinitionsApi - interface
 */
export interface RestComponentDefinitionsApiInterface {
    /**
     * 
     * @summary Create a new component definition
     * @param {BaseComponentDefinitionDto} baseComponentDefinitionDto Component definition creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComponentDefinition(baseComponentDefinitionDto: BaseComponentDefinitionDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDefinitionIdDto>;

    /**
     * 
     * @summary get component definition by id
     * @param {number} componentDefinitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComponentDefinitionById(componentDefinitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDefinitionDto>;

    /**
     * 
     * @summary Search for component definitions
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ComponentDefinitionSearchQueryDto} componentDefinitionSearchQueryDto Component definitions search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchComponentDefinitions(page: number, pageSize: number, componentDefinitionSearchQueryDto: ComponentDefinitionSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentDefinitionsSearchResponseDto>;

}

/**
 * RestComponentDefinitionsApi - object-oriented interface
 */
export class RestComponentDefinitionsApi extends BaseAPI implements RestComponentDefinitionsApiInterface {
    /**
     * 
     * @summary Create a new component definition
     * @param {BaseComponentDefinitionDto} baseComponentDefinitionDto Component definition creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComponentDefinition(baseComponentDefinitionDto: BaseComponentDefinitionDto, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionsApiFp(this.configuration).createComponentDefinition(baseComponentDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get component definition by id
     * @param {number} componentDefinitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getComponentDefinitionById(componentDefinitionId: number, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionsApiFp(this.configuration).getComponentDefinitionById(componentDefinitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for component definitions
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ComponentDefinitionSearchQueryDto} componentDefinitionSearchQueryDto Component definitions search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchComponentDefinitions(page: number, pageSize: number, componentDefinitionSearchQueryDto: ComponentDefinitionSearchQueryDto, options?: RawAxiosRequestConfig) {
        return RestComponentDefinitionsApiFp(this.configuration).searchComponentDefinitions(page, pageSize, componentDefinitionSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }
}

